/* src/modules/lessons/selectors.js */

import { createSelector } from 'reselect';
import { get, find, isEmpty, map, last } from 'lodash';

import { getMoment, createPageSelector } from '../../util';
import { loadTexts } from '../../config/texts';
const TEXT_KEY = 'lessons';

export const getLessons = createSelector(
  state => state.lessons.main.data.list,
  state => state.appState.locale,
  (lessons, locale) => {
    const texts = loadTexts(TEXT_KEY, locale);
    const { fields } = texts;
    // put sorting functions and stuff here
    if (isEmpty(lessons)) return [];
    return map(lessons, l => {
      const { _id, group, course, location, current, status, price, timeline } = l;
      const tf = get(l, 'group.tutor.user.first');
      const tl = get(l, 'group.tutor.user.last');
      const sf = get(l, 'group.studentMembers.0.student.user.first');
      const sl = get(l, 'group.studentMembers.0.student.user.last');

      let subject = 'Course '; let number = 'Not Available';
      // let university = { name: 'University Not Available' };
      if (course) ({ subject, number } = course);
      const time = getMoment(current.startTime.timestamp);
      return {
        [fields.tutor]: `${tf} ${tl}`,
        [fields.student]: `${sf} ${sl}`,
        [fields.course]: `${subject} ${number}`,
        // university: university.name,
        [fields.status]: status,
        [fields.location]: (location || { name: 'Not Available' }).name,
        [fields.created]: getMoment((timeline || [{ date: { timestamp: '0' } }])[0].date.timestamp).format('MMM D, Y'),
        [fields.time]: time.format('MMM D, Y'),
        [fields.price]: (price / 100).toFixed(2),
        _id,
      };
    });
  }
);

export const getLessonInfo = createSelector(
  state => state.lessons.main.data.list,
  state => state.lessons.single.data,
  (main, single) => {
    const def = {
      _id: '',
      tutor: 'tutor',
      student: 'student',
      course: 'course',
      status: 'status',
      location: 'location',
      address: 'address',
      date: 'date',
      time: 'time',
      price: 'price',
      studentFee: '0',
      tutorFee: '0',
      lastUpdated: 'last updated',
      charges: [],
    };
    if (isEmpty(single)) return def;
    const {
      group, course, location, current, status, price,
      studentFee,
      tutorFee,
      timeline,
      charges
    } = single;
    const address = get(single, 'location.address') || 'No address';
    const tutorID = get(single, 'group.tutor._id');
    const tf = get(single, 'group.tutor.user.first');
    const tl = get(single, 'group.tutor.user.last');
    const studentID = get(single, 'group.studentMembers.0.student._id');
    const sf = get(single, 'group.studentMembers.0.student.user.first');
    const sl = get(single, 'group.studentMembers.0.student.user.last');
    let subject = 'Course '; let number = 'Not Available';
    if (course) ({ subject, number } = course);
    const time = getMoment(current.startTime.timestamp);
    const lastUpdated = getMoment(last(timeline).date.timestamp);
    const duration = time.clone();
    duration.add(current.timeslots.length * 30, 'minutes');
    return {
      _id: single._id,
      tutor: `${tf} ${tl}`,
      tutorID,
      student: `${sf} ${sl}`,
      studentID,
      course: `${subject} ${number}`,
      status,
      location: (location || { name: 'Not Available' }).name,
      address,
      date: time.format('MMM D, Y'),
      time: `${time.format('HH:mm')} - ${duration.format('HH:mm')}`,
      price,
      studentFee: (studentFee / 100).toFixed(2),
      tutorFee: (tutorFee / 100).toFixed(2),
      lastUpdated: `${lastUpdated.format('MMM D, Y')} at ${lastUpdated.format('HH:mm')}`,
      canceled: (find(timeline, t => t.type === 'CANCEL') || { emitter: '' }).emitter,
      charges,
    };
  }
);

export const fetchLessonsState = createSelector(
  state => state.lessons.browse,
  ({ loading, error }) => ({ loading, error })
);

export const getLessonsListRange = createSelector(
  state => state.lessons.browse,
  ({ start, end, count }) => ({ start, end, count })
);

export const getSelected = createSelector(
  state => state.lessons.selected.lesson,
  lesson => {
    const { title, subject, number, _university, _id } = lesson;
    return {
      title,
      subject,
      number,
      _university,
      _id,
    };
  }
);

export const fetchLessonState = createSelector(
  state => state.lessons.selected,
  ({ loading, error }) => ({ loading, error })
);

export const getPageInfo = createPageSelector('lessons');



// WEBPACK FOOTER //
// ./src/modules/lessons/selectors.js